const messages = {
  fleetWithOptions:
    "Du kan ikkje velge flåte hvis du har valgt alternativer",
  addProduct: "Produktet ditt er lagt til i handlevogna.",
  addProducts: "Produktene dine er lagt til i handlevogna.",
  profileSaved: "Profilopplysningene dine er lagret",
  canAddProduct: "Du har ikkje nok poeng.",
  customerNumberSaved: "Kundenummer lagret",
  customerNumberExist: "Kundenummer tilgjengelig",
  complaintForm: "Forespørselen din er mottatt. Vennlegst vent på svar",
  openHourSaved: "Åpningstidene er lagret",
  changeParentId:
    "Du kan ikkje endre underavdelingen med høyere kundenummer hvis den har underordnede avdelinger.",
  requestSent: "Forespørselen er sendt",
  completeProfileRequired:
    "Du må fylle ut profilen din 100 % for å kunne fortsette handle i butikken.",
  accessDenied: "Tilgang nekta",
  incomplete_address: "Adressen er ufullstendig. Vennlegst sjekk",
  waitMoment: "Vent et øyeblikk",
  downloadFinished: "Nedlasting fullført",
  selectOneField: "Velg ett felt",
  noVoucher: "Kupongen vart ikkje funnet",
  cannotAddCsNumber: "Du kan ikkje legge til kundenummer",
  messagesDeletedSuccess: "Meldingene ble slettet.",
  messagesDeletedError: "Kunne ikkje slette meldinger.",
  fillProfile: "Fyll ut profilen for å kunne laste ned certifikatet.",
  favoriteAdded: "Lagt til i favoritter.",
  favoriteRemoved: "Fjernet fra favoritter.",
};

export default {
  messages,
};
